import * as React from "react"
import { SVGProps, memo } from "react"

const BigPlus = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 138 138" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_6092_9945)">
        <path
          d="M69 0c35.879 0 65 29.121 65 65 0 35.879-29.121 65-65 65-35.879 0-65-29.121-65-65C4 29.121 33.121 0 69 0zm-3.861 61.138H38.914c-5.149 0-5.149 7.722 0 7.722h26.225v26.386c0 4.988 7.722 4.988 7.722 0V68.86h26.386c4.988 0 4.988-7.722 0-7.722H72.861V34.913c0-5.148-7.722-5.148-7.722 0v26.225zM69 3.217c-34.107 0-61.78 27.673-61.78 61.78 0 34.27 27.673 61.944 61.78 61.944 34.27 0 61.944-27.673 61.944-61.943C130.944 30.89 103.27 3.217 69 3.217z"
          fill="#fff"
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_6092_9945"
          x={0}
          y={0}
          width={138}
          height={138}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6092_9945"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6092_9945"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

const MemoBigPlus = memo(BigPlus)
export default MemoBigPlus
